const initialState = {
  APP_NAME: 'Softsygn',
  user: undefined,
  usersList: [],
  casinosList: []
};

export default initialState;
